export default __webpack_public_path__ + "static/media/rfdigital_2.e5f76f35.png";